/**
 * Custom event kural semasi (tracker kopyasi).
 * Kaynak: tablet/services/webAnalytics/rules/rulesSchema.js — sabitler ayni kalmali.
 * Panel kopyasi: customer-panel/src/views/Pages/WebAnalytics/webAnalyticsRulesSchema.js
 */

export const TRIGGERS = {
    CLICK: "click",
    VISIBLE: "visible",
    SUBMIT: "submit",
    PAGEVIEW: "pageview",
    SDK: "sdk",
};

export const VALUE_SOURCES = ["attr", "text", "const", "field", "query", "global", "meta", "js"];

export const VALUE_TYPES = ["string", "number", "boolean"];

/** CSS secici zorunlu olan tetikleyiciler. */
export const SELECTOR_REQUIRED_TRIGGERS = [TRIGGERS.CLICK, TRIGGERS.VISIBLE, TRIGGERS.SUBMIT];

/** Sunucu tarafiyla ayni ust sinirlar. */
export const LIMITS = {
    maxRules: 200,
    maxPropsPerRule: 50,
    maxSelectorLength: 300,
    maxJsLength: 8000,
    maxValueLength: 500,
    maxStringifiedLength: 1000,
};

/** js / if govdelerinin azami calisma suresi. */
export const JS_TIMEOUT_MS = 3000;

/** visible tetikleyicisinde gorunurluk esigi ve suresi. */
export const VISIBLE_RATIO = 0.5;
export const VISIBLE_DURATION_MS = 1000;

/** Kural motorunun urettigi event'lerin kaynagi. */
export const RULE_SOURCE = "rule";



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/rules/schema.js
// module id = /cvC
// module chunks = 1 2